import { createRoute } from '@tanstack/react-router';
import { PojistovnaForm } from '@/modules/pujcovna/PojistovnaForm';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/sprava/pojistovny/nova',
  component: PojistovnaForm,
});
